import React from 'react'
import { useEffect } from 'react';
import { HoraSeleccionar } from './HoraSeleccionar';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import "react-modern-calendar-datepicker/lib/DatePicker.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import axios from 'axios';

import logo_sharecare1 from "../../assets/logo_sharecare1.png"

import FormularioPago from '../FormularioPago/FormularioPago';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from '@stripe/react-stripe-js';
import getPublishableKey from '../../stripe/publishableKey';

const stripe_publishable_key = getPublishableKey()
const stripePromise = loadStripe(stripe_publishable_key)

export const ModalAnadirPaqueteServicioSC = (props) => {
    const { ModalAnadirPaqueteServicioShareCare, setModalAnadirPaqueteServicioShareCare, Paquete, activeStep, MyDate, setMyDate, addMonths, generarListaDias, ListaHoras, EstadoConsulta, ModalSeleccionHora, setModalSeleccionHora, ModalSeleccionPaciente, setModalSeleccionPaciente, setActiveStep, ExampleCustomInput, changeHora, ListaPacientes, Paciente, seleccionarPaciente, modHoraModal, isStepSkipped, anadiServicioLista, getHoras, enviarYMostrarResultado, hayHora, getHorasShareCare, empresa, createPayment, get_clientSecret, clientSecret, stripeMessage, factura } = props;

    const options = {
        clientSecret,
        paymentMethodCreation: 'manual',
    }
    if (activeStep === 4) {
        document.getElementById('disable-button').style.display = 'none'
    } else {
        if (activeStep > 0) {
            document.getElementById('disable-button').style.display = 'grid'
        }
    }

    const steps = ["Resumen", "Pago", "Aceptar", "Estado"];

    /**
     * Llamar a una funcion que llame la lista de pacientes y calcule la distancia
     * 
    useEffect(() => {
        getRangoEmpresaPacientes();
    }, []);
    */

    const getHora = () => {
        let horaSel;
        ListaHoras.forEach(hora => {
            if (hora.estado == true) {
                horaSel = hora
            };
        });
        return horaSel;
    };

    const getClase = (paciente) => {
        let distancia = distance(paciente.lat, paciente.lon, empresa.sede.lat, empresa.sede.lng, 'K')
        if (distancia > empresa.sede.radio / 1000) {
            return (
                <div className='seleccionPacienteModal-Disable'>
                    <div className='fotoSeleccionPacienteModal centrador'>
                        <img
                            src={paciente.fotoPaciente}
                        />
                    </div>
                    <div className='nombreSeleccionPacienteModal centrador'>
                        <div>{paciente.nombrePaciente} {paciente.apellidosPaciente}</div>
                        <div>{paciente.direccionPaciente}</div>
                    </div>
                </div>
            )
        }
        if (paciente.id == Paciente.id) {
            return (
                <div className={'seleccionPacienteModal-Active'
                } onClick={() => seleccionarPaciente(paciente.id)}>
                    <div className='fotoSeleccionPacienteModal centrador'>
                        <img
                            src={paciente.fotoPaciente}
                        />
                    </div>
                    <div className='nombreSeleccionPacienteModal centrador'>
                        <div>{paciente.nombrePaciente} {paciente.apellidosPaciente}</div>
                        <div>{paciente.direccionPaciente}</div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={'seleccionPacienteModal'
                } onClick={() => seleccionarPaciente(paciente.id)}>
                    <div className='fotoSeleccionPacienteModal centrador'>
                        <img
                            src={paciente.fotoPaciente}
                        />
                    </div>
                    <div className='nombreSeleccionPacienteModal centrador'>
                        <div>{paciente.nombrePaciente} {paciente.apellidosPaciente}</div>
                        <div>{paciente.direccionPaciente}</div>
                    </div>
                </div>
            )

        }
    };


    function distance(lat1, lon1, lat2, lon2, unit) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit == "K") { dist = dist * 1.609344 }
            if (unit == "N") { dist = dist * 0.8684 }
            return dist;
        }
    }




    return (

        <Modal
            centered={true} isOpen={ModalAnadirPaqueteServicioShareCare}
        >
            <ModalHeader>
                <div className='titulo-modal'>

                    <>
                        {"Paquete de Servicios " + Paquete.nombrePaquete}
                    </>
                    <div />
                    {
                        (activeStep === 0) ?
                            <>
                                Seleccione a su paciente
                            </>
                            : (activeStep === 1) ?
                                <>
                                    Selecione el dia
                                </>
                                : (activeStep === 2) ?
                                    <>
                                        Seleccione la hora
                                    </>
                                    : (activeStep === 3)
                                        ? <>
                                            Confirmación
                                        </>
                                        : (activeStep === 4)
                                            ? <>
                                                Pago
                                            </>
                                            : (EstadoConsulta !== undefined)
                                                ? (EstadoConsulta)
                                                    ? <>Servicio contratado correctamente</>
                                                    : <>Algo salió mal</>
                                                : <>Realizando pre-reserva</>

                    }

                </div>


            </ModalHeader>
            <ModalBody><>
                <div className='calendario-modal-perfil-agencia'>
                    {
                        (activeStep === 0)
                            ? <div className='listaPacientesModal'>
                                <span class="MuiStepLabel-iconContainer Mui-active css-vnkopk-MuiStepLabel-iconContainer"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiStepIcon-root Mui-active css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" color='#bdbcbc'></circle></svg><text>&nbsp;Paciente fuera del rango del servicio</text></span>

                                {
                                    ListaPacientes.map(paciente => {
                                        return (getClase(paciente)
                                        )
                                    })
                                }
                            </div>
                            : (activeStep === 1)
                                ?
                                <>
                                    <div class="pedido-detalle">
                                        <div className='info'>Detalles de la contratación</div>
                                        <div className='separador' />
                                        <div className='info detalles'>
                                            Detalles del paciente
                                        </div>
                                        <div className="info-pedido">
                                            <div class="paciente-detalles">
                                                <div class="mod-hora-modal"><b>Nombre: </b>{Paciente.nombrePaciente}</div>
                                                <div class="mod-hora-modal"><b>Apellidos: </b>{Paciente.apellidosPaciente}</div>
                                                <div class="mod-hora-modal"><b>Dirección: </b>{Paciente.direccionPaciente}</div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                : (activeStep === 2)
                                    ? (clientSecret)
                                        ? <div>
                                            <Elements options={options} stripe={stripePromise} >
                                                <FormularioPago
                                                    factura={factura}
                                                    stripeMessage={stripeMessage}
                                                    createPayment={createPayment}
                                                    enviarYMostrarResultado={enviarYMostrarResultado}
                                                    setActiveStep={setActiveStep}
                                                    activeStep={activeStep} />
                                            </Elements>
                                        </div>
                                        : <div className="descripcion-servicio descripcion-modal">
                                            Cargando...
                                        </div>

                                    : (EstadoConsulta !== undefined)
                                        ? (EstadoConsulta)
                                            ? <div className="descripcion-servicio descripcion-modal">
                                                Su compra se ha procesado correctamente. Hemos enviado un correo electrónico a su dirección de correo electrónico con todos los detalles. ¡Gracias por confiar en Cuidatia!
                                            </div>
                                            : <div className="descripcion-servicio descripcion-modal">
                                                ¡Vaya! Algo salió mal y no se pudo procesar su solicitud. Por favor, inténtelo de nuevo más tarde o póngase en contacto con nuestro equipo de soporte si el problema persiste. ¡Gracias por su paciencia y comprensión!
                                            </div>
                                        : <div className="descripcion-servicio descripcion-modal">
                                            Cargando...
                                        </div>

                    }
                </div>
                <div className='steps-modal-pefil-empresa'>
                    <Box sx={{ width: '100%' }}>
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (isStepSkipped(index)) {
                                    stepProps.completed = false;
                                }
                                if ((index) < (steps.length - 1)) {
                                    return (
                                        <Step key={label} {...stepProps} className="step-perfil-empresa">
                                            <StepLabel {...labelProps}><div className='centrador'>{label}</div></StepLabel>
                                        </Step>
                                    );
                                };
                            })}
                        </Stepper>
                    </Box>
                </div>
                
                {/********************************************************************************************************************** */}
                <Modal centered={true} isOpen={ModalSeleccionPaciente}>
                    <ModalHeader>
                        <div className='titulo-modal'>
                            ¡Elige a tu héroe (paciente)!
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className='descripcion-servicio descripcion-modal'>
                            Para contratar nuestros servicios, elige un paciente registrado. Si no tienes uno, agrégalo fácilmente antes de contratar. Si tienes preguntas o necesitas ayuda, contáctanos. Estamos aquí para ayudarte.
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className='centrador'>
                            <div className='button' onClick={() => setModalSeleccionPaciente(false)}>
                                <b>Aceptar</b>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </></ModalBody>
            <ModalFooter>
                <div className='centrador-Botones-botones-perfil-empresa'>
                    {
                        (activeStep !== 5) &&
                        <div className='buttonB' onClick={() => {
                            anadiServicioLista();
                            if (activeStep > 0) {
                                setActiveStep(activeStep - 1);
                            } else {
                                setModalAnadirPaqueteServicioShareCare(false)
                            }
                        }
                        }>
                            {
                                (activeStep === 1)
                                    ? <b>Cancelar</b>
                                    : <b>Atrás</b>
                            }
                        </div>
                    }
                    <div id='disable-button' className='button' onClick={() => {
                        anadiServicioLista();
                        if (activeStep < steps.length) {
                            switch (activeStep) {
                                case 0:
                                    if (!Paciente || Object.keys(Paciente).length === 0) {
                                        setModalSeleccionPaciente(true);
                                    } else {
                                        setActiveStep(activeStep + 1);
                                    }
                                    break;
                                case 1:
                                    get_clientSecret()
                                    setActiveStep(activeStep + 1);
                                    break;
                                case 2:
                                    setActiveStep(activeStep + 1);
                                    break;
                                default:
                                    setModalAnadirPaqueteServicioShareCare(false);
                                    setActiveStep(activeStep - 4);
                                    break;
                            }
                        } else {
                            setModalAnadirPaqueteServicioShareCare(false);
                        }

                    }
                    }>
                        <b>
                            {
                                (activeStep === 4)
                                    ? 'Finalizar'
                                    : 'Siguiente'
                            }
                        </b>
                    </div>
                </div>
            </ModalFooter>
        </Modal>
    )
}
